import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export interface OrganizationGetListRequestFilter {
  code?: string | null;
  name?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
  email?: string | null;
  phoneAreaCode?: string | null;
  phone?: string | null;
  website?: string | null;
  apiKey?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
}

export type OrganizationGetListRequest = GetListRequest<OrganizationGetListRequestFilter>;

export type OrganizationGetListResponse = GetListResponse<Organization>;

export interface Organization {
  code?: string | null;
  name: string;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
  email?: string | null;
  phoneAreaCode?: string | null;
  phone?: string | null;
  website?: string | null;
  apiKey?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
  organizationToEventCategoryMaps: OrganizationToEventCategoryMapInsertRequest[];

  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
}

export interface OrganizationToEventCategoryMapInsertRequest {
  /** @format int64 */
  refEventCategory_Id?: number | null;
}

export type OrganizationDeleteRequest = DeleteRequest;

export interface OrganizationInsertRequest {
  code?: string | null;
  name: string;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
  email?: string | null;
  phoneAreaCode?: string | null;
  phone?: string | null;
  website?: string | null;
  apiKey?: string | null;
  isEnabled?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;
  organizationToEventCategoryMaps?: OrganizationToEventCategoryMapInsertRequest[];
}
